import { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { routes } from 'types/routes.ts'
import styles from 'pages/app/market-prices/MarketPrices.module.scss'
import MarketPricesContent from 'pages/app/market-prices/market-prices-content/MarketPricesContent.tsx'
import { useTranslation } from 'react-i18next'
import PageLayout from 'layouts/page-layout/PageLayout.tsx'
import { FaqSlugB2C } from 'types/faq.ts'
import useGetAccessRight from 'hooks/useSelectAccessRight.ts'
import { ACCESS_RIGHT_KEYS } from 'store/access-rights/constants.ts'

const MarketPrices = () => {
  // React router
  const navigate = useNavigate()

  // i18n
  const { t } = useTranslation('marketPrices')

  // Access rights
  const { todayTomorrow } = useGetAccessRight(ACCESS_RIGHT_KEYS.marketPrices)

  useEffect(() => {
    if (!todayTomorrow.canAccess) {
      void navigate(routes.CONSUMPTION_ELECTRICITY)
    }
  }, [todayTomorrow.canAccess, navigate])

  return (
    <PageLayout title={t(($) => $.title)} faqCategories={{ b2c: [FaqSlugB2C.MARKET_PRICES] }}>
      <section className={styles['market-prices-section']}>
        <MarketPricesContent />
      </section>
    </PageLayout>
  )
}

export default MarketPrices
